var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDialerVisible
    ? _c(_vm.componentType, {
        tag: "component",
        attrs: { "actions-type": _vm.actionsType, component: "page" },
        on: {
          "toggle-keypad": function ($event) {
            _vm.navigation = "keypad"
          },
          "toggle-members-page": function ($event) {
            _vm.navigation = "members"
          },
          "toggle-invite-page": function ($event) {
            _vm.navigation = "invite"
          },
          "toggle-transfer-page": function ($event) {
            _vm.navigation = "transfer"
          },
          "go-back": function ($event) {
            _vm.navigation = "main"
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }